export enum ItemPerRow {
    One = 'one',
    Two = 'two',
    Three = 'three',
    Four = 'four',
    Auto = 'auto'
}
